import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "config/api.config";
import {
  DatacontrolHistory,
  ChangeTreuhandstellePreferencesParams,
} from "types/datacontrol.types";
import { ValidationErrors } from "types/masterdata.types";

export const datacontrolApi = createApi({
  reducerPath: "datacontrol",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getHistory: builder.query<
      DatacontrolHistory,
      | {
          kundennummer: number;
        }
      | undefined
    >({
      query: (params) => ({
        method: "Get",
        url: "History/GetHistory",
        params,
      }),
    }),
    changeTreuhandstellePreferences: builder.mutation<
      ValidationErrors,
      ChangeTreuhandstellePreferencesParams | undefined
    >({
      query: (params) => ({
        method: "POST",
        url: "Treuhand/ChangeTreuhandstellePreferences",
        params,
      }),
    }),
  }),
});

export const {
  useGetHistoryQuery,
  useChangeTreuhandstellePreferencesMutation,
} = datacontrolApi;
